import script from "./CoreUiChatHistoryMessageContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageContent.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageContent.vue?vue&type=style&index=0&id=4c240ef8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c240ef8"]])

export default __exports__